<template>
	<div id="router-body">
		<div id="main-contents">
			<h3>サイト説明</h3>
			<p>
				ここはNandeのホームページPhantom Horizonです。<br>
				現在はブラウザ音楽ゲーム「Dancing★Onigiri」の自作譜面がメインコンテンツです。<br>
				リンク等はTOPページにしてもらえるとありがたいです。
			</p>

			<h3>サイト管理者「Nande」について</h3>
			<p>プロフィールはだいたいこちらに記載しています。→ <NewTabLink :linkURL="'https://twitter.com/nande_704'" :text="'https://twitter.com/nande_704'"></NewTabLink></p>
			
			<h3>ダークモードについて</h3>
			<p>
				ヘッダー右の「DarkMode」トグルをONにしてもらうと、黒基調のダークモードになります。<br>
				そちらのほうが好きな方はどうぞ。
			</p>

			<h3>「ダンおに」について</h3>
			<p>遊び方等は「<router-link to="/danoni">Dancing☆Onigiri</router-link>」のページに記載しています。</p>
		</div>
	</div>
</template>

<script>
import NewTabLink from '../components/NewTabLink.vue';
export default {
	components: {
		NewTabLink,
	}

}
</script>

<style scoped>
	#main-contents {
		padding: 16px;
		margin-top: 8px;
	}

</style>